import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTooltipV3 } from './TooltipV3.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTooltipV3({ prefix }));
}
